import type { PropsWithChildren, ReactNode } from "react";

type SectionProps = PropsWithChildren<{
  eyebrow?: string;
  title: string;
  intro?: string;
  aside?: ReactNode;
  className?: string;
  id?: string;
}>;

export function Section({ aside, children, className = "", eyebrow, id, intro, title }: SectionProps) {
  return (
    <section
      id={id}
      className={[
        "mb-6 rounded-[1.45rem] border border-white/10 bg-[linear-gradient(180deg,rgba(38,36,43,0.96),rgba(10,18,32,0.94))] p-4 shadow-panel sm:rounded-[1.65rem] sm:p-5 md:rounded-[1.8rem] md:p-6",
        className
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="mb-4 grid items-start gap-4 sm:mb-5 sm:gap-5 md:grid-cols-[minmax(0,1fr)_auto]">
        <div>
          {eyebrow ? (
            <p className="mb-3 text-[0.8rem] uppercase tracking-[0.14em] text-brand-300/80">
              {eyebrow}
            </p>
          ) : null}
          <h2 className="m-0 font-display text-[clamp(2rem,3vw,3rem)] leading-[0.96] tracking-[-0.03em]">
            {title}
          </h2>
          {intro ? <p className="mt-3 max-w-[48rem] text-[0.98rem] leading-7 text-stone-300/85 sm:text-base">{intro}</p> : null}
        </div>
        {aside ? <div className="md:justify-self-end">{aside}</div> : null}
      </div>
      {children}
    </section>
  );
}
